import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import Model from './model/Model'
import '@use-ui/bootstrap3/src/Select.scss'

const appModel = new Model()

ReactDOM.render(
  <React.StrictMode>
    <App appModel={appModel} />
  </React.StrictMode>,
  document.getElementById('root')
)
